module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }, [_vm._v("Introduction")])]), _c('a', {
    attrs: {
      "id": "pagevii"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('p', {
    staticClass: "imag"
  }, [_c('img', {
    attrs: {
      "alt": "figure",
      "src": "images/pvii.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("One of the most well-known photographs of the Battle of Britain – which fascinated the author as a child, inspiring this detailed study. Taken at Fowlmere after a patrol during the Battle of Britain, the strain on the face of twenty-three-year-old Squadron Leader Brian Lane DFC, the Commanding Officer of 19 Squadron, is all too evident. The other pilots are (left) Flight Lieutenant Jack ‘Farmer’ Lawson DFC and Flight Sergeant George ‘Grumpy’ Unwin DFM.")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _c('a', {
    attrs: {
      "id": "pageviii"
    }
  }, [_vm._v("On 21 September 1940 official photographers descended upon Manor Farm, Fowlmere, a hastily built satellite airfield to the nearby Sector Station at Duxford, near Cambridge – there to photograph the personnel and Spitfires of 19 Squadron. The images arising remain amongst the most well-known of the Battle of Britain. Several show a group of pilots, clutching after-action combat report forms, clustered around their young commander. In his face is etched the physical and mental strain of flying fighters during our Finest Hour. It is a haunting image – which fascinated me as a child.")])]), _c('a', {
    attrs: {
      "id": "pageviii"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Used to illustrate countless publications, invariably the photograph appeared with a generic caption failing to identify the exhausted looking squadron leader concerned. One day, I happened across a small firsthand memoir, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Spitfire! The Experiences of a Fighter Pilot")]), _vm._v(", by a ‘Squadron Leader B.J. Ellan’, published in 1942. Immediately I realised that ‘B.J. Ellan’ and the squadron commander whose photograph had so moved me were one and the same. I also knew that this was a pseudonym, because by then I had confirmed that this was Squadron Leader Brian John Edward Lane – the exceptional commander of 19 Squadron, who, by the time of the Battle of Britain, had already been awarded the Distinguished Flying Cross. Sadly, I had also discovered that he had been reported Missing in Action on 13 December 1942, aged twenty-five. I resolved there and then to research this young knight of the air’s life and times, rapidly confirming that here was an unsung hero indeed; I would soon discover that there were numerous other forgotten heroes, many of whom I was to meet personally on what became an emotionally-charged journey of discovery. What has left an indelible impression from this experience is the reverence in which all of the elderly and very experienced survivors held the twenty-five-year-old Squadron Leader Brian Lane, whose name was only ever spoken in hushed, respectful tones, the conversation inevitably condemning the wasteful circumstances of his loss.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My original work hoping to record and raise awareness of the story of Brian Lane and 19 Squadron during the early war period, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Spitfire Squadron")]), _vm._v(" was published in 1990. The book, my first, which included the first reprint of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Spitfire!")]), _vm._v(", was well received. During the years ahead, however, I came to enjoy a unique and privileged relationship with both many of the Squadron’s survivors from the traumatic days of 1940, and the families of casualties. Thirty years later we now have here the completely updated and rewritten "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Spitfire Squadron")]), _vm._v(" – with the benefit of a vast amount of extra information and infinitely more experience as an author and historian.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pageviii"
    }
  }), _c('a', {
    attrs: {
      "id": "pageix"
    }
  }, [_vm._v("This new version of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Spitfire Squadron")]), _vm._v(", incorporating unique first-hand accounts, seeks to locate the whole story within a much wider context, including social, political, aviation and military history. In this way, I hope that we can better understand and appreciate the experience of having served on a Spitfire squadron – indeed the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("first")]), _vm._v(" Spitfire squadron – during the pre- and critical early-Second World War periods. Importantly, the wartime photographs have mainly been copied from the personal albums of survivors and their families, providing an authentic and atmospheric glimpse of the ever-distant past.")])]), _c('a', {
    attrs: {
      "id": "pageix"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Hopefully, the spirits in my rear-view mirror, ever constant companions throughout the writing of this book, will consider that I have done them, their friends, and especially the revered ‘Brian’, justice. You, my readers, can decide.")]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_vm._v("Dilip Sarkar MBE FRHistS, ")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Worcester,")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("15 September 2018")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ea652e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Introduction.vue
// module id = 72
// module chunks = 0